import { Component, OnDestroy, OnInit } from '@angular/core';
import { News } from '../../models/news/news.model';
import { NewsService } from '../../services/news.service';
import { ToastsService } from '../../services/toasts.service';
import { Base } from '../base/base';
import * as _ from 'lodash';
import { EventTrackingService } from 'src/app/services/event-tracking.service';
import { EventName } from '../../../environments/environment';

@Component({
  selector: 'safetydirector-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css'],
  providers: [NewsService]
})
export class NewsComponent extends Base implements OnInit, OnDestroy {
  private BusyA;
  private BusyB;

  public news: News[];

  constructor(private newsService: NewsService, private toastsService: ToastsService, private eventTrackingService: EventTrackingService) {
    super();
  }

  trackImageClick(newsItem: any): void {
    this.eventTrackingService.trackEvent('TrackEvent', {
      'Event' : EventName.homeCarouselImageClicked
      ,'Url': newsItem.url
    });
  }

  downloadFile(url: string): void {
    const parameters = url.split('/');
    const container = parameters[0].split(':')[1];
    const fileName = parameters[1];
    const id = parameters[2];

    this.BusyB = this
      .newsService
      .downloadFile(container, fileName, id)
      .subscribe(result => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(result)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
        
        this.toastsService.showSuccess(`Successfully downloaded '${fileName}'`);
      });

  }

  ngOnInit(): void {
    const industry = this.getIndustry();

    this.BusyA = this
      .newsService
      .getNews(industry)
      .subscribe(result => {
        this.news = result;
        this.news = _.filter(this.news, n => (n.blobUrl != null && n.blobUrl != ''));
      });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }

    if (this.BusyB) {
      this.BusyB.unsubscribe();
    }
  }
}
